import axios from 'axios';
import store from '../store';
import {Notification as notify} from 'element-ui';
import router from '../router'
import i18n from './i18n'  //引入i18n

axios.interceptors.request.use(
  config => {
    config.headers['Source'] = 'web';
    if (store.getters.token) {
      config.headers['Authorization'] = store.getters.token;
    }
    config.headers['language'] = i18n.locale
    // console.log('config.headers[\'language\']=====>>',i18n.locale)
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      var message = error.response.data.error.message ? error.response.data.error.message : '';
      if (error.response.status === 401) {
        notify.error({
          message: i18n.locale==='en'?'Please login first':'請先登錄'
        });
        store.dispatch('Logout');
        router.replace({
          path: '/login',
          query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
        });
      } else if (message) {
        notify.error({message: message});
      } else {
        switch (error.response.status) {
          case 400:
            message = '请求错误(400)';
            break;
          case 401:
            message = '认证失效，请重新登录(401)';
            break;
          case 403:
            message = '拒绝访问(403)';
            break;
          case 404:
            message = `请求出错(404)`;
            break;
          case 408:
            message = '请求超时(408)';
            break;
          case 500:
            message = '服务器错误(500)';
            break;
          case 501:
            message = '服务未实现(501)';
            break;
          case 502:
            message = '网络错误(502)';
            break;
          case 503:
            message = '服务不可用(503)';
            break;
          case 504:
            message = '网络超时(504)';
            break;
          case 505:
            message = 'HTTP版本不受支持(505)';
            break;
          default:
            message = `连接出错(${err.response.status})!`;
            break;
        }
        notify.error({message: message});
      }
    }
    console.log(error);
    return Promise.reject(error.response.data);
    //return Promise.resolve(error);//请求错误时，不会直接结束，将会继续传到then里面,无论请求成功还是失败，在成功的回调中都能收到通知

  });

export default axios



// WEBPACK FOOTER //
// ./src/utils/axios.js